import * as React from "react";
const SvgFiRrBoxHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-box-heart_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v1c0 .883.391 1.67 1 2.22V19c0 2.757 2.243 5 5 5h12c2.757 0 5-2.243 5-5V8.22c.609-.549 1-1.337 1-2.22V5c0-2.757-2.243-5-5-5M2 5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v1c0 .551-.449 1-1 1H3c-.551 0-1-.449-1-1zm19 14c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V9h18zm-10.213.703c.363.296.808.444 1.252.444s.889-.148 1.251-.444c2.522-2.056 3.748-3.832 3.748-5.43 0-1.784-1.346-3.235-3-3.235-.768 0-1.469.312-2 .826a2.87 2.87 0 0 0-2-.826c-1.654 0-3 1.451-3 3.235 0 1.598 1.227 3.374 3.749 5.43m-.748-6.665c.551 0 1 .554 1 1.235a1 1 0 0 0 2 0c0-.681.449-1.235 1-1.235s1 .554 1 1.235c0 .428-.293 1.664-2.988 3.88-2.718-2.216-3.012-3.452-3.012-3.88 0-.681.449-1.235 1-1.235"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-box-heart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoxHeart;
